import { Button, makeStyles, Typography } from '@material-ui/core';
import { LBOrderDTO } from 'app/main/apps/scanner/types';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface SalesRowProps {
  sale: LBOrderDTO;
  className?: string;
  currency: string;
  onResetPointsInTag: () => void;
}

const useStyles = makeStyles(() => ({
  tagInfoWrapper: {
    width: '100%',
    borderRadius: '8px',
    padding: '8px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px 16px',
    backgroundColor: '#F5F5F5',
  },
}));

export const SaleRow: FC<SalesRowProps> = ({ sale, className, currency, onResetPointsInTag }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div key={sale.tagId} className={clsx('flex flex-col md:flex-row justify-center gap-16 mt-16', className)}>
      <div className={classes.tagInfoWrapper}>
        <Typography variant="body2" className="font-bold text-black">
          {t('dialogs.createSaleDialog.amount')}
        </Typography>
        <Typography variant="body2" className="font-bold text-black">
          {t('dialogs.createSaleDialog.points')}
        </Typography>

        <Typography variant="body2" color="textSecondary" className="font-semibold">
          {sale.amount} {currency}
        </Typography>
        <Typography variant="body2" color="textSecondary" className="font-semibold">
          {sale.points} pts
        </Typography>
      </div>
      <Button className="py-16" variant="outlined" size="medium" color="primary" onClick={() => onResetPointsInTag()}>
        <Typography variant="button" color="inherit">
          {t('basic.actions.reset')}
        </Typography>
      </Button>
    </div>
  );
};

export default SaleRow;
